import React, { useRef } from 'react';
import { styled } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import PropTypes from 'prop-types';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';

const StyledDialog = styled(Dialog)(() => {
  return {
    '.MuiDialog-paperWidthSm': {
      minWidth: '290px',
      margin: 0,
    },
    '.MuiDialogContent-root .MuiBox-root': {
      height: 'auto',
    },
    '.MuiDialog-paper': {
      maxWidth: '90%',
    },
  };
});

const BaseDialog = ({
  children,
  open,
  title,
  confirmText,
  confirmColor,
  onClose,
  onConfirm,
  onAdd,
  sx,
  ...properties
}) => {
  const inputAccountCodeReference = useRef('');

  return (
    <>
      <StyledDialog
        open={open}
        onClose={onClose}
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"
        sx={Object.assign(sx, {
          minWidth: '290px',
          margin: '0',
        })}
        {...properties}
      >
        <DialogTitle id="dialog-title">{title}</DialogTitle>
        <DialogContent>{children}</DialogContent>

        <Grid container spacing={2}>
          <Grid item xs={1} sm={1}></Grid>
          <Grid item xs={7} sm={7}>
            <TextField
              inputRef={inputAccountCodeReference}
              name="member_account_code"
              label="會員編號"
              fullWidth
              required
              variant={'standard'}
            />
          </Grid>
          <div style={{ paddingTop: 20 }}>
            <Grid item xs={3} sm={3}>
              <Button
                variant="contained"
                color="success"
                sx={{ color: 'white' }}
                onClick={() => {
                  onAdd(inputAccountCodeReference.current.value);
                  inputAccountCodeReference.current.value = '';
                }}
              >
                新增
              </Button>
            </Grid>
          </div>
        </Grid>

        <DialogActions sx={{ padding: '20px' }}>
          <Button
            onClick={onConfirm}
            variant="contained"
            color={confirmColor}
            sx={{ paddingLeft: '20px', paddingRight: '20px', minWidth: '5rem' }}
          >
            {confirmText}
          </Button>
        </DialogActions>
      </StyledDialog>
    </>
  );
};

BaseDialog.propTypes = {
  children: PropTypes.node,
  open: PropTypes.bool,
  title: PropTypes.string,
  confirmText: PropTypes.string,
  confirmColor: PropTypes.string,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  onAdd: PropTypes.func,
  sx: PropTypes.object,
};

BaseDialog.defaultProps = {
  title: '系統訊息',
  confirmText: '完成',
  confirmColor: 'primary',
  onClose: () => {},
  onConfirm: () => {},
  onAdd: () => {},
  sx: {},
};

export default BaseDialog;
